import { Component, OnInit, ViewContainerRef, Compiler, Injector, NgModuleRef, ViewChild, AfterViewInit, OnDestroy, NgModule, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-dynamic-html',
  templateUrl: './dynamic-html.component.html',
  styleUrls: ['./dynamic-html.component.scss']
})

export class DynamicHtmlComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('vc', { read: ViewContainerRef, static: false }) vc: ViewContainerRef;

  @Input() config: any = null;
  @Input() modelo: any = null;
  @Input() modeloExterno: any = { Nombre: "Hoaosd", Apellido: null };
  @Input() template: string = null;

  cmpRef: any = null;

  constructor(private _compiler: Compiler,
    private _injector: Injector,
    private _m: NgModuleRef<any>) { }

  //* FUNCIONES ANGULAR

  ngOnInit() {

    if (this.config) {
      if (this.config.Template)
        this.template = this.config.Template;
      if (this.config.Modelo)
        this.modeloExterno = this.config.Modelo;
    }

  }

  ngAfterViewInit() {

    if (!this.template)
      this.template = '<span>generated on the fly: {{name}}</span>';

    const that = this;
    const tmpCmp = Component({ template: this.template })(class {
      config: any = that.config;
      modelo: any = that.modelo;
      modeloExterno: any = { Nombre: "Hoaosd", Apellido: null };
    });
    const tmpModule = NgModule({
      declarations: [tmpCmp],
      imports: [
        FormsModule,
        CommonModule
      ]
    })(class {
    });

    this._compiler.compileModuleAndAllComponentsAsync(tmpModule)
      .then((factories) => {
        const f = factories.componentFactories[0];
        that.cmpRef = this.vc.createComponent(f);
        that.cmpRef.instance.name = 'dynamic';

        if (that.config) {
          // cmpRef.instance.config = this.config;
          /*  if (that.config.Modelo)
             that.modeloExterno = that.config.Modelo;
           if (that.config.Name) */
          that.cmpRef.instance.name = that.config.Name;
        }
        if (that.config.Modelo)
          that.cmpRef.instance.modeloExterno = that.config.Modelo;
        //cmpRef.instance.modelo = that.modelo;
      })

    // const template = '<span>I am {{name}}</span>';

    //   const tmpCmp = Component({template: template})(class {
    //   });
    //   const tmpModule = NgModule({declarations: [tmpCmp]})(class {
    //   });

    // this._compiler.compileModuleAndAllComponentsAsync(tmpModule)
    //     .then((factories) => {
    //         const f = factories.componentFactories[0];
    //         const cmpRef = f.create(this._injector, [], null, this._m);
    //         cmpRef.instance.name = 'B component';
    //         this._container.insert(cmpRef.hostView);
    //     })

  }

  ngOnDestroy() {

    if (this.cmpRef) {
      this.cmpRef.destroy();
    }

  }

  //* END FUNCIONES ANGULAR

}
